import React from "react";

function CompletedMatchCard({ match }) {
    const formatTime = (time) => {
        if (!time) return "--:--";
        const date = new Date(time);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const getWinner = () => {
        if (!match.winnerId) return "—";
        if (match.winnerId === match.team1Id) return match.team1Name;
        if (match.winnerId === match.team2Id) return match.team2Name;
        return "—";
    };

    const isTeam1Winner = match.winnerId === match.team1Id;
    const isTeam2Winner = match.winnerId === match.team2Id;

    return (
        <div className={`rcard ${isTeam1Winner ? "win" : "loss"}`}>
            <div className="rcard-body">
                <div className="rcard-top">
                    <span className="fmt-tag">Virtual IPL · #{match.matchId}</span>
                    <span className={`rbadge ${match.winnerId ? "rb-win" : "rb-loss"}`}>COMPLETED</span>
                </div>
                <div className="teams-line">
                    <div className="tblk">
                        <div className="tblk-logo">
                            <div className="tblk-emblem">
                                {match.team1PicURL ? (
                                    <img src={match.team1PicURL} alt={match.team1Name}
                                         style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                         onError={(e) => { e.target.style.display = 'none'; }} />
                                ) : "🏏"}
                            </div>
                            <div>
                                <div className="tblk-name">{match.team1Name}</div>
                                <div className={`tblk-score ${isTeam1Winner ? "hi" : "lo"}`}>
                                    {match.team1Runs !== null ? `${match.team1Runs}/${match.team1Wickets}` : "—"}
                                </div>
                                <div className="tblk-ov">
                                    {match.team1Overs !== null ? `${match.team1Overs} ov` : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cvs">VS</div>
                    <div className="tblk r">
                        <div className="tblk-logo" style={{ flexDirection: "row-reverse" }}>
                            <div className="tblk-emblem">
                                {match.team2PicURL ? (
                                    <img src={match.team2PicURL} alt={match.team2Name}
                                         style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                         onError={(e) => { e.target.style.display = 'none'; }} />
                                ) : "🏏"}
                            </div>
                            <div>
                                <div className="tblk-name">{match.team2Name}</div>
                                <div className={`tblk-score ${isTeam2Winner ? "hi" : "lo"}`}>
                                    {match.team2Runs !== null ? `${match.team2Runs}/${match.team2Wickets}` : "—"}
                                </div>
                                <div className="tblk-ov">
                                    {match.team2Overs !== null ? `${match.team2Overs} ov` : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rcard-foot">
                    <span className="rf-result">
                        {match.winnerId ? `${getWinner()} won` :
                            match.message && match.message.includes("drawn") ? "Match drawn" :
                                match.message && isNaN(match.message) ? match.message : "— won"}
                    </span>
                    <span className="rf-date">Today {formatTime(match.matchStartTime)}</span>
                </div>
            </div>
        </div>
    );
}

export default CompletedMatchCard;